import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Card,
  Col,
  Row,
  Tag,
  Divider,
  Space,
  Typography,
  message,
  Image,
  Spin,
  Modal,
  Switch,

} from "antd";
import {
  ArrowLeftOutlined,
  DownloadOutlined,
  CrownOutlined,
  StarOutlined,
  EnvironmentOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  FileDoneOutlined,
  CreditCardOutlined,
  FolderOpenOutlined,
  GlobalOutlined,
  EyeOutlined,
  CheckOutlined,
  CloseOutlined,
  CheckCircleOutlined,
  LeftOutlined,
  CloseCircleOutlined,
  StarFilled,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../../api";
import { getDateTimeString } from "../../Commonfunctions";
import RejectionModal from "./RejectionModal";
import "./MembersDetails.css"
import SponsorPlanModal from "./SponsorPlanModal";
import dayjs from "dayjs";

const { Title, Text } = Typography;

function MemberDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const memberData = location.state?.memberData || {};
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [openRejectionModal, setOpenRejectionModal] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [verifyUser, setVerifyUser] = useState(false)
  const [openSponsorModal, setOpenSponsorModal] = useState(false)
  const [actionType, setActionType] = useState("");
  const [isVerified, setIsVerified] = useState(memberData?.fld_verified_id === "1");
  const [isSponsored, setIsSponsored] = useState(memberData?.fld_is_sponsored_id === "1")
  const [previewSrc, setPreviewSrc] = useState("");

  const membershipCode = memberData.fld_membership_category_code;
  console.log("location.=-", location)

  const membershipType =
    membershipCode === "0"
      ? "gold"
      : membershipCode === "1"
        ? "silver"
        : membershipCode === "2"
          ? "bronze"
          : membershipCode === "3"
            ? "life"
            : "life";


  const documents = [
    {
      title: "PAN Card",
      subtitle: "Attachment",
      icon: <CreditCardOutlined />,
      src: memberData.fld_pan_card_attachment_path,
    },
    {
      title: "GST Certificate",
      subtitle: "Registration",
      icon: <FileDoneOutlined />,
      color: "green",
      src: memberData.fld_gst_registration_certificate_path,
    },
    {
      title: "ITR - Last Year",
      subtitle: "Returns",
      icon: <FileTextOutlined />,
      color: "orange",
      src: memberData.fld_last_3_year_balance_sheet_path,
    },
    {
      title: "ITR - 3 Years",
      subtitle: "Returns",
      icon: <FolderOpenOutlined />,
      color: "gray",
      src: memberData.fld_last_3_year_gst_return_path,
    },
  ];

  // Theme settings for each type
  const themes = {
    gold: {
      gradient: "linear-gradient(135deg, #6B7280, #E5E7EB)",
      iconColor: "#4B5563",
      border: "#9CA3AF",
      textColor: "#374151",
    },
    silver: {
      gradient: "linear-gradient(135deg, #6B7280, #E5E7EB)",
      iconColor: "#4B5563",
      border: "#9CA3AF",
      textColor: "#374151",
    },
    bronze: {
      gradient: "linear-gradient(135deg, #6B7280, #E5E7EB)",
      iconColor: "#4B5563",
      border: "#9CA3AF",
      textColor: "#374151",
    },
    life: {
      gradient: "linear-gradient(135deg, #6B7280, #E5E7EB)",
      iconColor: "#4B5563",
      border: "#9CA3AF",
      textColor: "#374151",
    },
  };

  const getSponsorTheme = (planId) => {
    // if (!planId) return themes.bronze;
    // if (planId === "1") {
    //   return themes.bronze
    // } else if (planId === "2") {
    //   return themes.silver
    // } else if (planId === "3") {
    //   return themes.gold
    // }
    return themes.life
  };

  const current = themes.life;
  const currentSponsorTheme = themes.life;

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Registration Successfully Approved",
      style: {
        marginTop: "22vh",
      },
    });
  };

  const error = () => {
    messageApi.open({
      type: "error",
      content: "Registration Successfully Rejected",
      style: {
        marginTop: "22vh",
      },
    });
  };

  const redirect = () => {
    setTimeout(() => {
      navigate(-1);
    }, 2000);
  };


  const handleDeactivateSponsor = async () => {
    try {
      const payload = {
        "master_tbl_register": [
          {
            fld_rf_id: memberData.fld_rf_id ?? "",
            fld_role_id: memberData.fld_role_id ?? "",
            fld_role_name: memberData.fld_role_name ?? "",
            fld_registred_mobile_number: memberData.fld_registred_mobile_number ?? "",
            fld_company_press_sw_id: memberData.fld_company_press_sw_id ?? "",
            fld_company_press_id: memberData.fld_company_press_id ?? "",
            fld_company_press_name: memberData.fld_company_press_name ?? "",
            fld_logo_brand_upload_path: memberData.fld_logo_brand_upload_path ?? "",
            fld_legal_entity_type_id: memberData.fld_legal_entity_type_id ?? "",
            fld_legal_entity_type_name: memberData.fld_legal_entity_type_name ?? "",
            fld_year_established: memberData.fld_year_established ?? "",
            fld_head_office_address: memberData.fld_head_office_address ?? "",
            fld_country_sw_id: memberData.fld_country_sw_id ?? "",
            fld_country_id: memberData.fld_country_id ?? "",
            fld_country_name: memberData.fld_country_name ?? "",
            fld_state_sw_id: memberData.fld_state_sw_id ?? "",
            fld_state_id: memberData.fld_state_id ?? "",
            fld_state_name: memberData.fld_state_name ?? "",
            fld_district_sw_id: memberData.fld_district_sw_id ?? "",
            fld_district_id: memberData.fld_district_id ?? "",
            fld_district_name: memberData.fld_district_name ?? "",
            fld_city_sw_id: memberData.fld_city_sw_id ?? "",
            fld_city_id: memberData.fld_city_id ?? "",
            fld_city_name: memberData.fld_city_name ?? "",
            fld_pincode: memberData.fld_pincode ?? "",
            fld_contact_person_name: memberData.fld_contact_person_name ?? "",
            fld_contact_person_phone_number: memberData.fld_contact_person_phone_number ?? "",
            fld_contact_person_email_number: memberData.fld_contact_person_email_number ?? "",
            fld_company_category_id: memberData.fld_company_category_id ?? "",
            fld_company_category_name: memberData.fld_company_category_name ?? "",
            fld_sub_category_id: memberData.fld_sub_category_id ?? "",
            fld_sub_category_name: memberData.fld_sub_category_name ?? "",
            fld_servces_products_id: memberData.fld_servces_products_id ?? "",
            fld_servces_products_name: memberData.fld_servces_products_name ?? "",
            fld_certifications_id: memberData.fld_certifications_id ?? "",
            fld_certifications_name: memberData.fld_certifications_name ?? "",
            fld_last_year_turnover: memberData.fld_last_year_turnover ?? "",
            fld_brand_repersented_id: memberData.fld_brand_repersented_id ?? "",
            fld_brand_repersented_name: memberData.fld_brand_repersented_name ?? "",
            fld_company_bio_about: memberData.fld_company_bio_about ?? "",
            fld_pan_number: memberData.fld_pan_number ?? "",
            fld_gstin_number: memberData.fld_gstin_number ?? "",
            fld_pan_card_attachment_path: memberData.fld_pan_card_attachment_path ?? "",
            fld_gst_registration_certificate_path: memberData.fld_gst_registration_certificate_path ?? "",
            fld_last_3_year_balance_sheet_path: memberData.fld_last_3_year_balance_sheet_path ?? "",
            fld_last_3_year_gst_return_path: memberData.fld_last_3_year_gst_return_path ?? "",
            fld_website_url: memberData.fld_website_url ?? "",
            fld_linkedin_page_link: memberData.fld_linkedin_page_link ?? "",
            fld_whatsapp_business_link: memberData.fld_whatsapp_business_link ?? "",
            fld_geo_x: memberData.fld_geo_x ?? "",
            fld_geo_y: memberData.fld_geo_y ?? "",
            fld_is_full_form_completed_form: memberData.fld_is_full_form_completed_form ?? "",
            fld_form_start_time: memberData.fld_form_start_time ?? "",
            fld_form_end_time: memberData.fld_form_end_time ?? "",
            fld_loggedin_user_id: memberData.fld_loggedin_user_id ?? "",
            fld_offline_kopa_registration_date: memberData.fld_offline_kopa_registration_date ?? "",
            fld_app_version: memberData.fld_app_version ?? "",
            fld_approval_rejection_date: memberData.fld_approval_rejection_date ?? "",
            fld_reason_for_rejection: memberData.fld_reason_for_rejection ?? "",
            // Set to empty strings for deactivation
            fld_is_sponsored_id: "",
            fld_is_sponsored_name: "",
            fld_sponsorship_plan_id: "",
            fld_sponsorship_plan_name: "",
            fld_sponsorship_start_date: "",
            fld_sponsorship_end_date: "",
            fld_sponsorship_renewed_count: memberData.fld_sponsorship_renewed_count ?? "",
            fld_is_approval_rejection: memberData?.fld_is_approval_rejection,
            fld_is_approval_rejection_name: memberData?.fld_is_approval_rejection_name,
          }
        ],
        "synceddatetime": "2025-05-29 10:08:00",
        "FormCode": "201",
        "AppVersion": "1.0.0.0",
        "ApiKey": "kavin",
        "AppTypeNo": "3"
      };

      const response = await api.activateSponsor(payload);

      if (response.data.status === "1") {
        messageApi.success("Sponsorship Deactivated Successfully");
        setIsSponsored(false);
        setTimeout(() => {
          navigate("/main/directory");
        }, 2000);
      }

    } catch (error) {
      console.log("deactivation error", error);
      messageApi.error("Failed to deactivate sponsorship");
    }
  };





  const handleActivateSponsor = async (planData) => {
    try {
      const payload = {
        "master_tbl_register": [
          {
            fld_rf_id: memberData.fld_rf_id ?? "",
            fld_role_id: memberData.fld_role_id ?? "",
            fld_role_name: memberData.fld_role_name ?? "",
            fld_registred_mobile_number: memberData.fld_registred_mobile_number ?? "",
            fld_company_press_sw_id: memberData.fld_company_press_sw_id ?? "",
            fld_company_press_id: memberData.fld_company_press_id ?? "",
            fld_company_press_name: memberData.fld_company_press_name ?? "",
            fld_logo_brand_upload_path: memberData.fld_logo_brand_upload_path ?? "",
            fld_legal_entity_type_id: memberData.fld_legal_entity_type_id ?? "",
            fld_legal_entity_type_name: memberData.fld_legal_entity_type_name ?? "",
            fld_year_established: memberData.fld_year_established ?? "",
            fld_head_office_address: memberData.fld_head_office_address ?? "",
            fld_country_sw_id: memberData.fld_country_sw_id ?? "",
            fld_country_id: memberData.fld_country_id ?? "",
            fld_country_name: memberData.fld_country_name ?? "",
            fld_state_sw_id: memberData.fld_state_sw_id ?? "",
            fld_state_id: memberData.fld_state_id ?? "",
            fld_state_name: memberData.fld_state_name ?? "",
            fld_district_sw_id: memberData.fld_district_sw_id ?? "",
            fld_district_id: memberData.fld_district_id ?? "",
            fld_district_name: memberData.fld_district_name ?? "",
            fld_city_sw_id: memberData.fld_city_sw_id ?? "",
            fld_city_id: memberData.fld_city_id ?? "",
            fld_city_name: memberData.fld_city_name ?? "",
            fld_pincode: memberData.fld_pincode ?? "",
            fld_contact_person_name: memberData.fld_contact_person_name ?? "",
            fld_contact_person_phone_number: memberData.fld_contact_person_phone_number ?? "",
            fld_contact_person_email_number: memberData.fld_contact_person_email_number ?? "",
            fld_company_category_id: memberData.fld_company_category_id ?? "",
            fld_company_category_name: memberData.fld_company_category_name ?? "",
            fld_sub_category_id: memberData.fld_sub_category_id ?? "",
            fld_sub_category_name: memberData.fld_sub_category_name ?? "",
            fld_servces_products_id: memberData.fld_servces_products_id ?? "",
            fld_servces_products_name: memberData.fld_servces_products_name ?? "",
            fld_certifications_id: memberData.fld_certifications_id ?? "",
            fld_certifications_name: memberData.fld_certifications_name ?? "",
            fld_last_year_turnover: memberData.fld_last_year_turnover ?? "",
            fld_brand_repersented_id: memberData.fld_brand_repersented_id ?? "",
            fld_brand_repersented_name: memberData.fld_brand_repersented_name ?? "",
            fld_company_bio_about: memberData.fld_company_bio_about ?? "",
            fld_pan_number: memberData.fld_pan_number ?? "",
            fld_gstin_number: memberData.fld_gstin_number ?? "",
            fld_pan_card_attachment_path: memberData.fld_pan_card_attachment_path ?? "",
            fld_gst_registration_certificate_path: memberData.fld_gst_registration_certificate_path ?? "",
            fld_last_3_year_balance_sheet_path: memberData.fld_last_3_year_balance_sheet_path ?? "",
            fld_last_3_year_gst_return_path: memberData.fld_last_3_year_gst_return_path ?? "",
            fld_website_url: memberData.fld_website_url ?? "",
            fld_linkedin_page_link: memberData.fld_linkedin_page_link ?? "",
            fld_whatsapp_business_link: memberData.fld_whatsapp_business_link ?? "",
            fld_geo_x: memberData.fld_geo_x ?? "",
            fld_geo_y: memberData.fld_geo_y ?? "",
            fld_is_full_form_completed_form: memberData.fld_is_full_form_completed_form ?? "",
            fld_form_start_time: memberData.fld_form_start_time ?? "",
            fld_form_end_time: memberData.fld_form_end_time ?? "",
            fld_loggedin_user_id: memberData.fld_loggedin_user_id ?? "",
            fld_offline_kopa_registration_date: memberData.fld_offline_kopa_registration_date ?? "",
            fld_app_version: memberData.fld_app_version ?? "",
            fld_approval_rejection_date: memberData.fld_approval_rejection_date ?? "",
            fld_reason_for_rejection: memberData.fld_reason_for_rejection ?? "",
            fld_is_sponsored_id: "1",
            fld_is_sponsored_name: "sponsored",
            fld_sponsorship_plan_id: String(planData.fld_sponsorship_plan_id),
            fld_sponsorship_plan_name: planData.fld_sponsorship_plan_name,
            fld_sponsorship_start_date: planData.fld_sponsorship_start_date,
            fld_sponsorship_end_date: planData.fld_sponsorship_end_date,
            fld_sponsorship_renewed_count: memberData.fld_sponsorship_renewed_count
              ? String(Number(memberData.fld_sponsorship_renewed_count) + 1)
              : "1",
            fld_is_approval_rejection: memberData?.fld_is_approval_rejection,
            fld_is_approval_rejection_name: memberData?.fld_is_approval_rejection_name,

          }
        ],
        "synceddatetime": "2025-05-29 10:08:00",
        "FormCode": "201",
        "AppVersion": "1.0.0.0",
        "ApiKey": "kavin",
        "AppTypeNo": "3"
      }



      const response = await api.activateSponsor(payload);


      if (response.data.status === "1") {
        messageApi.success("Sponsorship Activated Successfully");

        setIsSponsored(true);
        setOpenSponsorModal(false);
        setTimeout(() => {
          navigate("/main/directory");
        }, 2000);
      }

    } catch (error) {
      console.log("registration approving or rejecting error", error);
    }


  }
  const handleApproveReject = (type, rejectreason) => {
    const handleapicall = async (data) => {
      try {
        setLoading(true);
        const response = await api.registrationApproveReject(data);

        if (type === "approve" && response.data.status === "1") {
          success();
          redirect();
        } else if (type === "reject" && response.data.status === "1") {
          redirect();
          error();
          setOpenRejectionModal(false);
        }
      } catch (error) {
        console.log("registration approving or rejecting error", error);
      } finally {
        setLoading(false);
      }
    };

    const buildPayload = (type) => {
      const baseData = {
        fld_rf_id: memberData.fld_rf_id ?? "",
        fld_role_id: memberData.fld_role_id,
        fld_role_name: memberData.fld_role_name,
        fld_registred_mobile_number: memberData.fld_registred_mobile_number,
        fld_company_press_sw_id: memberData.fld_company_press_sw_id,
        fld_company_press_id: memberData.fld_company_press_id,
        fld_company_press_name: memberData.fld_company_press_name,
        fld_logo_brand_upload_path: memberData.fld_logo_brand_upload_path ?? "",
        fld_legal_entity_type_id: memberData.fld_legal_entity_type_id,
        fld_legal_entity_type_name: memberData.fld_legal_entity_type_name,
        fld_year_established: memberData.fld_year_established,
        fld_head_office_address: memberData.fld_head_office_address,
        fld_country_sw_id: memberData.fld_country_sw_id,
        fld_country_id: memberData.fld_country_id,
        fld_country_name: memberData.fld_country_name,
        fld_state_sw_id: memberData.fld_state_sw_id,
        fld_state_id: memberData.fld_state_id,
        fld_state_name: memberData.fld_state_name,
        fld_district_sw_id: memberData.fld_district_sw_id,
        fld_district_id: memberData.fld_district_id,
        fld_district_name: memberData.fld_district_name,
        fld_city_sw_id: memberData.fld_city_sw_id,
        fld_city_id: memberData.fld_city_id,
        fld_city_name: memberData.fld_city_name,
        fld_pincode: memberData.fld_pincode,
        fld_contact_person_name: memberData.fld_contact_person_name,
        fld_contact_person_phone_number: memberData.fld_contact_person_phone_number,
        fld_contact_person_email_number: memberData.fld_contact_person_email_number,
        fld_company_category_id: memberData.fld_company_category_id,
        fld_company_category_name: memberData.fld_company_category_name,
        fld_sub_category_id: memberData.fld_sub_category_id,
        fld_sub_category_name: memberData.fld_sub_category_name,
        fld_servces_products_id: memberData.fld_servces_products_id,
        fld_servces_products_name: memberData.fld_servces_products_name,
        fld_certifications_id: memberData.fld_certifications_id,
        fld_certifications_name: memberData.fld_certifications_name,
        fld_last_year_turnover: memberData.fld_last_year_turnover,
        fld_brand_repersented_id: memberData.fld_brand_repersented_id,
        fld_brand_repersented_name: memberData.fld_brand_repersented_name,
        fld_company_bio_about: memberData.fld_company_bio_about,
        fld_pan_number: memberData.fld_pan_number,
        fld_gstin_number: memberData.fld_gstin_number,
        fld_pan_card_attachment_path: memberData.fld_pan_card_attachment_path ?? "",
        fld_gst_registration_certificate_path:
          memberData.fld_gst_registration_certificate_path ?? "",
        fld_last_3_year_balance_sheet_path:
          memberData.fld_last_3_year_balance_sheet_path ?? "",
        fld_last_3_year_gst_return_path:
          memberData.fld_last_3_year_gst_return_path ?? "",
        fld_website_url: memberData.fld_website_url ?? "",
        fld_linkedin_page_link: memberData.fld_linkedin_page_link ?? "",
        fld_whatsapp_business_link: memberData.fld_whatsapp_business_link ?? "",
        fld_geo_x: memberData.fld_geo_x,
        fld_geo_y: memberData.fld_geo_y,
        fld_bussiness_type: memberData.fld_bussiness_type || "",
        fld_bussiness_type_file_upload_path: memberData.fld_bussiness_type_file_upload_path || "",
        fld_no_of_employee: memberData.fld_no_of_employee || "",
        fld_additional_contacts: memberData.fld_additional_contacts || "",
        fld_additional_emails: memberData.fld_additional_emails || "",
        fld_is_full_form_completed_form:
          memberData.fld_is_full_form_completed_form ?? "1",
        fld_form_start_time: memberData.fld_form_start_time,
        fld_form_end_time: memberData.fld_form_end_time,
        fld_loggedin_user_id: memberData.fld_loggedin_user_id ?? "",
        fld_offline_kopa_registration_date: memberData.fld_offline_kopa_registration_date ?? "M",
        fld_app_version: memberData.fld_app_version ?? "v1.0.0.0",
        fld_approval_rejection_date: getDateTimeString(),
        fld_reason_for_rejection: rejectreason ?? "",
      };

      const approvalData =
        type === "approve"
          ? {
            fld_is_approval_rejection: "1",
            fld_is_approval_rejection_name: "approved",
          }
          : {
            fld_is_approval_rejection: "2",
            fld_is_approval_rejection_name: "rejected",
          };

      const payload = {
        master_tbl_register: [
          {
            ...baseData,
            ...approvalData,
          },
        ],
        synceddatetime: getDateTimeString(),
        formcode: "101",
        appversion: "1.0.0.0",
        apikey: "kavin",
        apptypeno: "3",
      };

      return payload;
    };

    const payload = buildPayload(type);
    handleapicall(payload);
  };


  const handleOnSwitch = async () => {
    const newVerifiedState = !isVerified;

    const requestData = {
      synceddatetime: "2025-05-29 10:08:00",
      FormCode: "201",
      AppVersion: "1.0.0.0",
      ApiKey: "kavin",
      AppTypeNo: "3",
      fld_rf_id: memberData?.fld_rf_id,
      fld_verified_id: newVerifiedState ? "1" : "0",
      fld_verified_name: newVerifiedState ? "verified" : "unverified",
    };


    try {
      const response = await api.verifyUser(requestData);

      if (response.data.status === "1") {
        messageApi.success(newVerifiedState ? 'User Verified Successfully' : 'User UnVerified Successfully')
        setIsVerified(newVerifiedState);
        //setVerifyUser(false)
        redirect();
      }
    } catch (error) {
      console.error("Verification error:", error);
    }
  };

  return (
    <Spin spinning={loading}>
      {contextHolder}
      <div className="member-details-container">
        <Space
          align="center"
          style={{
            width: "100%",
            justifyContent: "space-between",
            padding: "8px 16px",
          }}
        >
          <Button
            icon={<LeftOutlined />}
            type="link"
            onClick={() => navigate(-1)}
            style={{ fontSize: 16 }}
          >
            Back
          </Button>


        </Space>


        <div className="member-details-content">
          {/* Header */}
          <div className="member-details-header">
            <Space align="center">
              <Avatar
                size={48}
                src={memberData.fld_logo_brand_upload_path}
              >
                {!memberData.fld_logo_brand_upload_path && memberData.fld_company_press_name?.charAt(0)}
              </Avatar>
              <div>{memberData.fld_company_press_name || memberData.fld_staff_name}</div>
              {memberData.fld_role_name !== 'admin' && <Tag bordered={false} color={memberData.fld_role_name === 'printer' ? "processing" : "volcano"}>{memberData.fld_role_name === 'printer' ? 'Life Member' : memberData.fld_role_name === 'staff' ? 'Staff' : 'Service Member'}</Tag>}
              {/* {memberData.fld_role_name !== 'vendor' &&
                <div style={{ display: "flex", alignItems: "center", height: 32 }}>
                  <Button
                    type="default"
                    icon={<CreditCardOutlined />}
                    className="member-details-status-type"
                  >
                    Online Payment Status
                  </Button>
                  <Button
                    type="default"
                    icon={<CheckCircleOutlined />}
                    className="member-details-status-value"
                  >
                    Success
                  </Button>
                </div>} */}
            </Space>

            <Space>
              {/* <Button icon={<DownloadOutlined />}>Download</Button> */}

              {memberData && memberData.fld_is_approval_rejection === "1" && (
                <Space align="center" size="middle">
                  <Text strong style={{ fontSize: 15, marginLeft: 15 }}>{isVerified ? 'Verified User' : 'Verify User'}</Text>
                  <Switch
                    checked={isVerified}
                    checkedChildren="Yes"
                    unCheckedChildren="No"
                    style={{
                      backgroundColor: isVerified ? "#52c41a" : "#d9d9d9",
                      boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                      transform: "scale(1.1)",
                    }}
                    onChange={() => {
                      setVerifyUser(true);
                      setOpenRejectionModal(true);
                    }}
                  />
                </Space>
              )}
              {/* {memberData.fld_role_name?.toLowerCase() === "vendor" && memberData.fld_is_approval_rejection === "1" &&
                <Space align="center" size="middle">
                  <Text strong style={{ fontSize: 15, marginLeft: 15 }}>Activate Sponsorship</Text>

                  <Switch
                    checked={isSponsored}   // correct
                    checkedChildren="Yes"
                    unCheckedChildren="No"
                    style={{
                      backgroundColor: isSponsored ? "#52c41a" : "#d9d9d9",
                      boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                      transform: "scale(1.1)",
                    }}
                    onChange={(checked) => {
                      if (checked) {
                        setOpenSponsorModal(true);
                      } else {
                        handleDeactivateSponsor();
                      }
                    }}
                  />
                </Space>
              } */}

              {/* {memberData.fld_role_name?.toLowerCase() !== "vendor" &&
                <Space.Compact>
                  {/* <Button>{memberData?.fld_membership_type_name}</Button> 
                  {membershipType === "gold" ? (
                    <Button className="member-details-gold-badge">
                      Gold
                    </Button>
                  ) : membershipType === "silver" ? (
                    <Button className="member-details-silver-badge">
                      Silver
                    </Button>
                  ) : membershipType === "bronze" ? (
                    <Button className="member-details-bronze-badge">
                      Bronze
                    </Button>
                  ) : (
                    <Button className="member-details-life-badge">
                      Life
                    </Button>
                  )}
                </Space.Compact>} */}
            </Space>
          </div>

          {/* Contact & Location + Membership */}
          <Row gutter={[24, 24]}>
            {/* Contact & Location */}
            <Col xs={24} md={12}>
              <Card
                title={
                  <Space>
                    <EnvironmentOutlined style={{ color: "#0072B1" }} />
                    <span>Contact & Location</span>
                  </Space>
                }
                bordered
                className="member-details-contact-card"
              >
                <Space direction="vertical" size="small" style={{ width: "100%" }}>
                  <div>
                    <Text type="secondary">Head Office Address</Text>
                    <br />
                    <Text>{memberData.fld_head_office_address || "N/A"}</Text>
                  </div>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Text type="secondary">Country</Text>
                      <br />
                      <Text>{memberData.fld_country_name || "N/A"}</Text>
                    </Col>
                    <Col span={12}>
                      <Text type="secondary">State</Text>
                      <br />
                      <Text>{memberData.fld_state_name || "N/A"}</Text>
                    </Col>
                  </Row>
                  <div>
                    <Text type="secondary">District</Text>
                    <br />
                    <Text>{memberData.fld_district_name || "N/A"}</Text>
                  </div>

                  {/* <div>
                    <Text type="secondary">City</Text>
                    <br />
                    <Text>{memberData.fld_city_name || "N/A"}</Text>
                  </div> */}

                  <div>
                    <Text type="secondary">Email</Text>
                    <br />
                    <Text>{memberData.fld_contact_person_email_number || "N/A"}</Text>
                  </div>

                  <div>
                    <Text type="secondary">Registered Mobile</Text>
                    <br />
                    <Text>{memberData.fld_registred_mobile_number || "N/A"}</Text>
                  </div>
                  <div>
                    <Text type="secondary">Pin Code</Text>
                    <br />
                    <Text>{memberData.fld_pincode || "N/A"}</Text>
                  </div>
                  <Divider />
                  <div>
                    <Text type="secondary">Contact Person</Text>
                    <br />
                    <Text>{memberData.fld_contact_person_name || "N/A"}</Text>
                  </div>
                  <div>
                    <Text type="secondary">Contact Phone</Text>
                    <br />
                    <Text>{memberData.fld_contact_person_phone_number || "N/A"}</Text>
                  </div>
                </Space>
              </Card>
            </Col>


            {/* Conditional Section */}
            <Col xs={24} md={12}>
              {memberData.fld_role_name?.toLowerCase() === "vendor" ? (
                // If role is vendor, show KYC Verification here instead of Membership
                <>
                  {isSponsored &&
                    <Card
                      title={
                        <Space>
                          <StarFilled style={{ color: currentSponsorTheme.iconColor }} />
                          <span>Sponsorship Details</span>
                        </Space>
                      }
                      bordered
                      style={{
                        background: currentSponsorTheme.gradient,
                        borderRadius: 8,
                        border: `1px solid ${currentSponsorTheme.border}`,
                        color: currentSponsorTheme.textColor,
                      }}
                      bodyStyle={{ padding: "12px 16px" }}
                    >
                      {/* Top section */}
                      {/* <div className="member-details-current-plan">
                        <div>
                          <Text type="secondary">Current Plan</Text>
                          <br />
                          <Title
                            level={5}
                            style={{ margin: 0, color: currentSponsorTheme.textColor }}
                          >
                            {memberData.fld_sponsorship_plan_name}
                          </Title>
                        </div>

                        <CrownOutlined style={{ color: currentSponsorTheme.iconColor, fontSize: 24 }} />
                      </div> */}

                      {/* Row details */}
                      <Row gutter={16} style={{ marginTop: 16 }}>
                        <Col span={12}>
                          <Text type="secondary">Start Date</Text>
                          <br />
                          <Text style={{ color: currentSponsorTheme.textColor }}>
                            {memberData.fld_sponsorship_start_date
                              ? dayjs(memberData.fld_sponsorship_start_date).format("DD MMM YYYY hh:mm A")
                              : "N/A"}
                          </Text>
                        </Col>

                        <Col span={12}>
                          <Text type="secondary">End Date</Text>
                          <br />
                          <Text style={{ color: currentSponsorTheme.textColor }}>

                            {memberData.fld_sponsorship_end_date
                              ? dayjs(memberData.fld_sponsorship_end_date).format("DD MMM YYYY hh:mm A")
                              : "N/A"}
                          </Text>
                        </Col>
                      </Row>

                      <Row gutter={16} style={{ marginTop: 16 }}>
                        <Col span={12}>
                          <Text type="secondary">Renewed Count</Text>
                          <br />
                          <Text style={{ color: currentSponsorTheme.textColor }}>
                            {memberData.fld_sponsorship_renewed_count || "0"}
                          </Text>
                        </Col>

                        <Col span={12}>
                          <Text type="secondary">Status</Text>
                          <br />
                          <Tag color={memberData.fld_is_sponsored_id === "1" ? "gold" : "default"}>
                            {memberData.fld_is_sponsored_name || "N/A"}
                          </Tag>
                        </Col>
                      </Row>
                    </Card>}

                  <Card
                    title={
                      <Space>
                        <FileProtectOutlined style={{ color: "#0072B1" }} />
                        <span>KYC Verification</span>
                      </Space>
                    }
                    style={{ marginTop: '15px' }}
                    bordered
                    className="member-details-kyc-card"
                    bodyStyle={{ padding: "12px 16px" }}
                  >
                    <Row gutter={16}>
                      <Col span={12}>
                        <Text type="secondary">PAN Number</Text>
                        <br />
                        <Text strong>{memberData.fld_pan_number || "N/A"}</Text>
                      </Col>
                      <Col span={12}>
                        <Text type="secondary">GSTIN</Text>
                        <br />
                        <Text strong>{memberData.fld_gstin_number || "N/A"}</Text>
                      </Col>
                    </Row>
                  </Card>
                </>
              ) : (
                <>
                
                  <Card
                    title={
                      <Space>
                        <StarOutlined style={{ color: current.iconColor }} />
                        <span>Membership Details</span>
                      </Space>
                    }
                    bordered
                    className="member-details-membership-card"
                    style={{
                      background: current.gradient,
                      borderRadius: 8,
                      border: `1px solid ${current.border}`,
                      color: current.textColor,
                    }}
                  >
                    {/* <div
                    className="member-details-current-plan"
                  >
                    <div>
                      <Text type="secondary">Current Plan</Text>
                      <br />
                      <Title level={5} style={{ margin: 0, color: current.textColor }}>
                         {memberData?.fld_membership_type_name ? memberData?.fld_membership_type_name : ""}
                      </Title>
                    </div>
                    <CrownOutlined style={{ color: current.iconColor, fontSize: 24 }} />
                  </div> */}

                    <Row gutter={16}>
                      <Col span={12}>
                        <Text type="secondary">Member Since</Text>
                        <br />
                        <Text style={{ color: current.textColor }}>
                          {memberData.fld_year_established || "N/A"}
                        </Text>
                      </Col>
                      <Col span={12}>
                        <Text type="secondary">Account Status</Text>
                        <br />
                        <Tag color={
                          memberData.fld_is_approval_rejection === "1" ? "green" :
                            memberData.fld_is_approval_rejection === "2" ? "red" : "orange"
                        }>
                          {memberData.fld_is_approval_rejection === "1" ? "Active" :
                            memberData.fld_is_approval_rejection === "2" ? "Rejected" : "Pending Review"}
                        </Tag>
                      </Col>
                    </Row>

                    {/* <div style={{ marginTop: 12 }}>
                    <Text type="secondary">Verification Status</Text>
                    <br />
                    <Tag color="orange">Pending Review</Tag>
                  </div> */}
                  </Card>


                  <Card
                    title="Approval Details"
                    style={{ marginTop: 16 }}
                  >
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Text type="secondary">Approval Status</Text>
                        <br />
                        <Text>{memberData.fld_is_approval_rejection_name || "N/A"}</Text>
                      </Col>

                      <Col span={12}>
                        <Text type="secondary">Approval Date</Text>
                        <br />
                        <Text>{memberData.fld_approval_rejection_date || "N/A"}</Text>
                      </Col>

                      <Col span={12}>
                        <Text type="secondary">Verification</Text>
                        <br />
                        <Text>{memberData.fld_verified_name || "N/A"}</Text>
                      </Col>

                      <Col span={12}>
                        <Text type="secondary">Verified Date</Text>
                        <br />
                        <Text>{memberData.fld_verified_datetime || "N/A"}</Text>
                      </Col>
                    </Row>
                  </Card>
                </>
              )}
            </Col>
          </Row>




          <Card
            title="Company Details"
            style={{ marginTop: 16 }}
          >
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Text type="secondary">Company ID</Text>
                <br />
                <Text>{memberData.fld_company_press_id || "N/A"}</Text>
              </Col>

              <Col span={12}>
                <Text type="secondary">Legal Entity</Text>
                <br />
                <Text>{memberData.fld_legal_entity_type_name || "N/A"}</Text>
              </Col>

              <Col span={12}>
                <Text type="secondary">Established Year</Text>
                <br />
                <Text>{memberData.fld_year_established || "N/A"}</Text>
              </Col>

              <Col span={12}>
                <Text type="secondary">District</Text>
                <br />
                <Text>{memberData.fld_district_name || "N/A"}</Text>
              </Col>

              {/* <Col span={12}>
                <Text type="secondary">City</Text>
                <br />
                <Text>{memberData.fld_city_name || "N/A"}</Text>
              </Col>   */}

              <Col span={12}>
                <Text type="secondary">Category</Text>
                <br />
                <Text>{memberData.fld_company_category_name || "N/A"}</Text>
              </Col>

              <Col span={12}>
                <Text type="secondary">Sub Category</Text>
                <br />
                <Text>{memberData.fld_sub_category_name || "N/A"}</Text>
              </Col>

              <Col span={12}>
                <Text type="secondary">Products / Services</Text>
                <br />
                <Text>{memberData.fld_servces_products_name || "N/A"}</Text>
              </Col>

              <Col span={24}>
                <Text type="secondary">Company Bio</Text>
                <br />
                <Text>{memberData.fld_company_bio_about || "N/A"}</Text>
              </Col>
            </Row>
          </Card>


          {/* KYC Verification */}
          {memberData.fld_role_name?.toLowerCase() !== "vendor" &&
            <Card
              title={
                <Space>
                  <FileProtectOutlined style={{ color: "#0072B1" }} />
                  <span>KYC Verification</span>
                </Space>
              }
              bordered
              className="member-details-kyc-card"
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Text type="secondary">PAN Number</Text>
                  <br />
                  <Text strong>{memberData.fld_pan_number || "N/A"}</Text>
                </Col>
                <Col span={12}>
                  <Text type="secondary">GSTIN</Text>
                  <br />
                  <Text strong>{memberData.fld_gstin_number || "N/A"}</Text>
                </Col>
              </Row>
            </Card>}

          {/* Documents */}
          <div>
            <Space align="center">
              <FileTextOutlined style={{ color: "#0072B1" }} />
              <Title level={5} style={{ margin: 0 }}>
                Documents
              </Title>
            </Space>

            <Row gutter={[24, 24]} style={{ marginTop: 16 }}>
              {documents
                .filter((doc) => doc.src) // only show cards with data
                .map((doc, i) => (
                  <Col xs={24} sm={12} md={6} key={i}>
                    <Card
                      hoverable
                      className="member-details-document-card"
                    >
                      <div style={{ color: doc.color || "#0072B1" }}>
                        {doc.icon}
                      </div>
                      <Title level={5} style={{ marginTop: 8 }}>
                        {doc.title}
                      </Title>
                      <Text type="secondary">{doc.subtitle}</Text>
                      <Button
                        icon={<EyeOutlined />}
                        block
                        size="small"
                        style={{ marginTop: 12 }}
                        onClick={() => {
                          setPreviewSrc(doc.src);
                          setPreviewVisible(true);
                        }}
                      >
                        View
                      </Button>
                    </Card>
                  </Col>
                ))}
            </Row>




          </div>

          {/* Online Presence */}
          <Card
            title={
              <Space>
                <GlobalOutlined style={{ color: "#0072B1" }} />
                <span>Online Presence</span>
              </Space>
            }
            bordered
            className="member-details-online-card"
          >
            <Row gutter={16}>
              {[
                { label: "Website", value: memberData.fld_website_url },
                { label: "LinkedIn", value: memberData.fld_linkedin_page_link },
                { label: "WhatsApp", value: memberData.fld_whatsapp_business_link },
              ].map((field) => (
                <Col xs={24} sm={8} key={field.label}>
                  <Text type="secondary">{field.label}</Text>
                  <br />
                  <Text>{field.value || "N/A"}</Text>
                </Col>
              ))}
            </Row>
          </Card>

          {/* Footer Buttons */}
          {(memberData.fld_is_approval_rejection === "0" ||
            memberData.fld_is_approval_rejection === "") && (
              <div
                className="member-details-footer-buttons"
              >

                <Button
                  type="primary"
                  icon={<CheckCircleOutlined />}
                  style={{
                    background: "linear-gradient(135deg, #73E2A7, #52C41A)",
                    borderRadius: 8,
                    fontWeight: 500,
                    padding: "0 16px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                  }}
                  onClick={() => {
                    setVerifyUser(false);
                    setActionType("approve");
                    setOpenRejectionModal(true);
                  }}
                >
                  Approve
                </Button>

                <Button
                  type="primary"
                  icon={<CloseCircleOutlined />}
                  style={{
                    borderRadius: 8,
                    fontWeight: 500,
                    background: "linear-gradient(135deg, #FF7A7A, #FF4D4F)",
                    padding: "0 16px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                  }}
                  onClick={() => {
                    setVerifyUser(false);
                    setActionType("reject");
                    setOpenRejectionModal(true);
                  }}
                >
                  Reject
                </Button>

              </div>
            )}
          {memberData.fld_is_approval_rejection === "2" && (
            <div
              className="member-details-footer-buttons"
            >
              <Button
                type="primary"
                icon={<CheckCircleOutlined />}
                style={{
                  background: "linear-gradient(135deg, #73E2A7, #52C41A)",
                  borderRadius: 8,
                  fontWeight: 500,
                  padding: "0 16px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                }}
                onClick={() => {
                  setVerifyUser(false);
                  setActionType("approve");
                  setOpenRejectionModal(true);
                }}
              >
                Approve
              </Button>
            </div>
          )
          }
        </div>
      </div>

      {/* Image Preview Modal */}
      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
        style={{ padding: 0, textAlign: "center" }}
      >
        <img
          src={previewSrc}
          alt="Document Preview"
          className="member-details-preview-image"
        />
      </Modal>

      {openRejectionModal && (
        <RejectionModal
          title={
            verifyUser
              ? isVerified
                ? "Unverify User"
                : "Verify User"
              : actionType === "approve"
                ? "Approve Application"
                : "Reject Application"
          }
          content={
            verifyUser
              ? isVerified
                ? "Are you sure you want to mark this user as unverified?"
                : "Are you sure you want to mark this user as verified?"
              : actionType === "approve"
                ? "Are you sure you want to approve this application?"
                : "Are you sure you want to reject this application?"
          }
          buttonName={verifyUser
            ? isVerified
              ? "Unverify"
              : "Verify"
            : actionType === "approve"
              ? "Approve"
              : "Reject"}
          open={openRejectionModal}
          onClose={() => setOpenRejectionModal(false)}
          onSubmit={(reason) => {
            if (verifyUser) handleOnSwitch();
            else if (actionType === "approve") handleApproveReject("approve", reason);
            else handleApproveReject("reject", reason);
          }}
        />

      )}
      {openSponsorModal && (
        <SponsorPlanModal
          open={openSponsorModal}
          onClose={() => {
            setOpenSponsorModal(false);
            setIsSponsored(false);
          }}
          onSubmit={(data) => handleActivateSponsor(data)}
        />
      )}


    </Spin>
  );
}

export default MemberDetails;